var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"resize-handle",class:{ 'is-resizing': _vm.isResizing },on:{"mousedown":function($event){$event.preventDefault();return _vm.startResize.apply(null, arguments)},"touchstart":function($event){$event.preventDefault();return _vm.startResize.apply(null, arguments)}}},[_c('div',{staticClass:"resize-indicator"})])
}
var staticRenderFns = []

export { render, staticRenderFns }